export const MY_CHECK_IN_PASSES_PATH = "/public/check-in-passes";
